import Vue from 'vue';

import OrderItemCard from './OrderItemCard';
import Board from './Board';

Vue.component('brku-order-item-card', OrderItemCard);
Vue.component('brku-order-board', Board);